import { on } from 'delegated-events';

on('click', '.js-print', (event) => {
  event.preventDefault();
  window.print();
});
